export const AI_INTERVIEW_COMPLETED = 'AI_INTERVIEW_COMPLETED' as const;

export type QualtricsCompletionMessage = {
  type: typeof AI_INTERVIEW_COMPLETED;
  sessionId: string;
  responseId?: string;
  studyId?: string;
  completedAt: string;
};

export function notifyQualtricsInterviewCompleted({
  sessionId,
  responseId,
  studyId,
  qualtricsOrigin,
}: {
  sessionId: string;
  responseId?: string;
  studyId?: string;
  /** One or more postMessage targetOrigins (e.g. preview + production Qualtrics). */
  qualtricsOrigin: string | readonly string[];
}): void {
  if (typeof window === 'undefined' || window.parent === window) return;

  const message: QualtricsCompletionMessage = {
    type: AI_INTERVIEW_COMPLETED,
    sessionId,
    responseId,
    studyId,
    completedAt: new Date().toISOString(),
  };

  const origins = (Array.isArray(qualtricsOrigin) ? qualtricsOrigin : [qualtricsOrigin])
    .map((o) => o.trim())
    .filter(Boolean);

  for (const origin of origins) {
    window.parent.postMessage(message, origin);
  }
}
